import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { SignatureComponent } from '@syncfusion/ej2-angular-inputs';
import { CommonService } from '../../../../../shared/services/common.service';
import { UserProfileService } from '../../../services/user-profile.service';

@Component({
    selector: 'app-signature-popup',
    templateUrl: './signature-popup.component.html',
    styleUrl: './signature-popup.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignaturePopupComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('signature') signatureCanvas!: SignatureComponent;
  @Input("signatureImage") signatureImage: any;
  @Input("isSignatureRequired") isSignatureRequired: any;
  @Input("userId") userId: string = '';
  @Output() onCloseSignaturePopup = new EventEmitter();
  @Output() onSaveSignaturePopup = new EventEmitter();
  isSignatureChanged: boolean = false;

  constructor(private commonService: CommonService, private usersService: UserProfileService) { }

  ngOnInit(): void {  }
  ngAfterViewInit(): void {
    this.signatureCanvas.load(this.signatureImage);
  }

  saveSignature(): void {
    this.usersService.apiCallStarted("saveSignature");
    let payload = {
      signature: this.signatureCanvas.getSignature(),
      userId: this.userId
    }
    this.usersService.saveUserSignatureById(payload)
      .subscribe({
        next: (res: any) => {
          this.usersService.apiCallCompleted("saveSignature");
          this.commonService.showNotification('info', res?.message);
          this.onSaveSignaturePopup.emit({modifiedSignature: this.signatureCanvas.getSignature()});
        },
        error: (err: any) => {
          this.commonService.showNotification('error', err?.error?.message);
          this.usersService.apiCallCompleted("saveSignature");
        }
      });
  }
  changeSignature() {
    this.isSignatureChanged = true;
    this.signatureImage = this.signatureCanvas.getSignature();
  }
  close() {
    // if(this.isSignatureChanged) {
    //   this.commonService.showNotification('info', "You need to save the signature!");
    // } else
    if(!this.signatureImage && this.isSignatureRequired) {
      this.commonService.showNotification('info', "Signature is required!");
    } else
     {
      this.onCloseSignaturePopup.emit();
    }
  }

  ngOnDestroy(): void {
    this.signatureCanvas.destroy();
  }
}
